/* jshint esversion: 6 */
import axios from 'axios';

/*
 * The suggested-feed catalogue: categories, and the feeds under each.
 *
 * Extracted from SuggestedFeeds so the new find step can read the same
 * catalogue. That component is a function component and fetches from an effect;
 * CreateFeed is a class and fetches from componentDidMount, so the two can't
 * share a hook — they share these functions instead, which keeps one copy of the
 * endpoints and of the shapes they return.
 *
 * A feed carries `dsfc_id` naming its category, plus `feed_title`,
 * `feed_description`, `feed_url` and `feed_icon`.
 */

function get(url) {
    return axios({
        url: url,
        method: 'GET',
        withCredentials: true,
        responseType: 'json'
    }).then((response) => {
        return response.data;
    });
}

export function fetchSuggestedFeedCategories(appUrl) {
    return get(`${appUrl}/utilities?suggestedFeedCategories=1`);
}

export function fetchSuggestedFeeds(appUrl) {
    return get(`${appUrl}/utilities?suggestedFeeds=1`);
}
